<template>
  <div>
    <activity-list v-show="tabType === 1" @handleShow="handleShow" />
    <activity-show v-if="tabType === 2" :rowItem="rowItem" @handleShow="handleShow"/>
  </div>
</template>

<script>
import activityList from './list.vue'
import activityShow from './show.vue'
export default {
  components: { activityList,activityShow },
  data() {
    return {
      tabType: 1,
      rowItem: null,
      technicalState:null
    }
  },
  methods: {
    handleShow(row, type) {
      this.tabType=type
      this.rowItem = { ...row }
    }
  }
}
</script>

<style>
</style>
